import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const AuthorInfo = ({ author, cssClass, publishDate, cssDataClass }) => {
  const { i18n } = useTranslation();
  const isEs = _.isEqual(i18n.language, 'es');
  return (
    <div className={cssClass}>
      {author && author.photo && (
        <LazyLoadImage
          src={author && author.photo}
          height="44px"
          width="44px"
        />
      )}
      {author && author.name && (
        <div className={cssDataClass}>
          <span>{isEs ? 'Por' : 'By'}</span>&nbsp;
          <a
            href={author && author.reviewerPageOnSingleCare}
            target="_blank"
            rel="noreferrer"
          >
            {author && author.name}
            {_.isEmpty(publishDate) &&
              author &&
              author.qualifications &&
              ', ' + author.qualifications}
          </a>
          {!_.isEmpty(publishDate) && <span>&nbsp;|&nbsp;{publishDate}</span>}
        </div>
      )}
    </div>
  );
};

export default AuthorInfo;
